module.exports = __webpack_public_path__ + "media/images/emblems/Vuarrens-coat_of_arms-5160a370128eef4345cccea3608f85ff.svg";